export const RESET_STATE = 'orders-imports-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_IMPORT_FILE = 'orders-imports-modal/GET_IMPORT_FILE';
export const getImportFileAction = payload => ({
	type: GET_IMPORT_FILE,
	payload,
});

export const GET_DOWNLOAD_ORDERS_TEMPLATE = 'orders-imports-modal/GET_DOWNLOAD_ORDERS_TEMPLATE';

export const getDownloadOrdersTemplateAction = () => ({
	type: GET_DOWNLOAD_ORDERS_TEMPLATE,
});

export const SET_IS_IMPORTED_FILE_LOADING = 'orders-imports-modal/SET_IS_IMPORTED_FILE_LOADING';
export const setIsImportedFileLoadingAction = payload => ({
	type: SET_IS_IMPORTED_FILE_LOADING,
	payload,
});
